/**
 * Links to the sibling surfaces: the Platform Console (apps/admin — Workflow Studio, Integrations, AI Governance, Audit & Security)
 * and the AI Workspace (apps/assistant — chat with departmental assistants, cross-workspace inbox, knowledge). Hosts come from
 * `VITE_ADMIN_URL` / `VITE_ASSISTANT_URL` when set (the Ministry's internal hosts set them at build: the console under
 * ncp.moet.gov.ae/admin, ECONIC on econic.moet.gov.ae); otherwise derived from this host (`backoffice.<domain>` → `admin.<domain>` /
 * `ai.<domain>`), falling back to the Vite dev ports.
 */
type Surface = "admin" | "assistant";

const DEV_PORTS: Record<Surface, number> = { admin: 5175, assistant: 5176 };
const SUBDOMAIN: Record<Surface, string> = { admin: "admin", assistant: "ai" };

function derive(surface: Surface): string {
  if (typeof window === "undefined") return "";
  const { protocol, hostname, port } = window.location;
  if (hostname === "localhost" || hostname === "127.0.0.1") return `${protocol}//${hostname}:${DEV_PORTS[surface]}`;
  const host = hostname.startsWith("backoffice.") ? hostname.replace(/^backoffice\./, `${SUBDOMAIN[surface]}.`) : `${SUBDOMAIN[surface]}.${hostname}`;
  return `${protocol}//${host}${port ? `:${port}` : ""}`;
}

export const ADMIN_URL: string = import.meta.env.VITE_ADMIN_URL || derive("admin");
export const ASSISTANT_URL: string = import.meta.env.VITE_ASSISTANT_URL || derive("assistant");

export function adminHref(path = "/"): string {
  return `${ADMIN_URL}${path.startsWith("/") ? path : `/${path}`}`;
}

export function assistantHref(path = "/"): string {
  return `${ASSISTANT_URL}${path.startsWith("/") ? path : `/${path}`}`;
}
